import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'my-surveys',
  children: {
    membershipId: {
      path: ':membershipId',
    },
  },
} as const satisfies Location
